import {useEffect} from 'react';

import ContextProvider from '../../components/App/ContextProvider/ContextProvider';
import progressBar from '../../components/App/ProgressBar/ProgressBar';
import PublicRouter from '../../components/App/PublicRouter/PublicRouter';
import {ExtendedRoutingProvider} from '../../components/ExtendedRouting/ExtendedRoutingProvider';
import analyticsService from '../../services/analytics';
import authenticationService from '../../services/api/authentication';
import scrollingService from '../../services/scrolling';

import './colors.module.css';
import './fonts.module.css';
import './spacing.css';
import './responsive.css';
import './global.css';
import './metaData.css';
import './role-style.css';
import './variableEmbed.css';
import 'antd/dist/reset.css';

export default function App() {
  useEffect(() => {
    progressBar.initialize();
    analyticsService.initialize();
    scrollingService.listenForPageChanges();
    authenticationService.initialize();
  }, []);

  return (
    <ContextProvider>
      <ExtendedRoutingProvider>
        <PublicRouter />
      </ExtendedRoutingProvider>
    </ContextProvider>
  );
}
